<ng-template #recordContainer></ng-template>